import { arrowGenerator } from '../../helpers'
import { StyleFn } from '..'

export const Tooltip: StyleFn = ({ color, elevation, font, opacity, size }) => {
  const backgroundColor = color.getModalValues(color.background.inverse)
  const borderColor = color.getModalValues(color.border.highlight)
  const { root: arrowRoot, arrow } = arrowGenerator(4, backgroundColor)

  return {
    root: {
      position: 'absolute',
      zIndex: elevation.zindex.tooltip,
      fontSize: font.size.small,
      lineHeight: font.lineheight.small,
      backgroundColor,
      color: color.type === 'light' ? color.palette.white : color.palette.coolgrey[90],
      padding: `${size.spacing[6]} ${size.spacing[8]}`,
      borderRadius: '3px',
      boxShadow: '0 3px 10px 0 rgba(0,0,0,0.20)',
      opacity: opacity.tooltip,
      ...arrowRoot,
    },
    arrow,
    _large: {
      fontSize: font.size.medium,
      lineHeight: font.lineheight.medium,
      padding: `${size.spacing[8]} ${size.spacing[10]}`,
      "&[data-popper-placement^='top']": {
        borderTop: `4px solid ${borderColor}`,
      },
      "&[data-popper-placement^='bottom']": {
        borderBottom: `4px solid ${borderColor}`,
      },
      "&[data-popper-placement^='left']": {
        borderLeft: `4px solid ${borderColor}`,
      },
      "&[data-popper-placement^='right']": {
        borderRight: `4px solid ${borderColor}`,
      },
    },
    title: {
      fontWeight: font.weight.bold,
    },
  }
}
